import { useTrackPageView } from '@zelostech/zem-react';
import { PropsWithChildren, ReactElement, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

interface PageInfo {
  pathname: string;
  search: string;
  hash: string;
  title: string;
}

export const RouteTracker: React.FC<PropsWithChildren> = ({ children }) => {
  const location = useLocation();
  const trackPageView = useTrackPageView();

  // 使用 ref 保存上一个页面信息
  const prevPageRef = useRef<PageInfo | null>(null);

  useEffect(() => {
    // 解析查询参数
    const searchParams = new URLSearchParams(location.search);
    const queryParams: Record<string, string> = {};
    searchParams.forEach((value, key) => {
      queryParams[key] = value;
    });

    // 当前页面信息
    const currentPage = {
      pathname: location.pathname,
      search: location.search,
      hash: location.hash,
      title: document.title,
    };

    // 执行埋点上报
    trackPageView(location.pathname, document.title, {
      pathname: location.pathname,
      query: queryParams,
      hash: location.hash,
      // 上报上一个页面信息
      prevPage: prevPageRef.current,
    });

    // 更新上一个页面信息为当前页面
    prevPageRef.current = currentPage;
  }, [location.pathname, location.search, location.hash, trackPageView]);

  return children as ReactElement;
};
